import React, { useState, useContext, useEffect } from "react";
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  QuerySnapshot,
} from "firebase/firestore";
import Comment from "./Comment";
import AddComment from "./AddComment";
import { Box, Card, Grid, Link, Button } from "@mui/material";
import { ColorModeContext } from "../context/ColorModeProvider";
import { useUserProvider } from "../context/UserProvider";
import { firestore } from "../firebase";

const Comments = ({ comments, onCreate, filesRef }) => {
  const { theme } = useContext(ColorModeContext);
  const { user } = useUserProvider();
  // const [eachComment, setEachComment] = useState("");

  // useEffect(() => {
  //   const collectionRef = collection(firestore, "sites");
  //   const q = query(collectionRef, orderBy("createAt", "desc"));
  //   const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
  //     setEachComment(
  //       QuerySnapshot.docs.map((doc) => ({
  //         ...doc.data(),
  //         id: doc.id,
  //         createAt: doc.data().createAt?.toDate().getTime(),
  //       }))
  //     );
  //   });
  // });
  // console.log();
  return (
    <>
      {/* <Card
        sx={{
          backgroundColor:
            theme.palette.mode === "dark" ? "#080C14" : "#F4F5F7",
          marginBottom: "30px",
          padding: "2em 2em",
        }}
      > */}
      {comments?.map((comment) => (
        <Comment {...comment} {...user} key={comment.createAt} />
      ))}
      {!user ? (
        <Grid align="right">
          <Link to="/login" style={{ textDecoration: "none" }}>
            <Button
              component="a"
              // endIcon={<EditIcon fontSize="small" />}
              sx={{ mt: 2 }}
              variant="outlined"
              size="small"
            >
              Sign in write a comment
            </Button>
          </Link>
        </Grid>
      ) : (
        <AddComment onCreate={onCreate} />
      )}
    </>
  );
};

export default Comments;
